import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { LgaDto, StateDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-lga-view',
  templateUrl: './lga-view.component.html',
  styleUrls: ['./lga-view.component.css'],
})
export class LgaViewComponent implements OnInit {
  @Input() lgas: LgaDto[];
  @Input() states: StateDto[];
  lgaForm: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<LgaDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  selectedCountry: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedStateId: any;
  filteredLga: Array<any> = [];
  status: boolean;
  selectedLgaId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.lgaForm = this.fb.group({ Lgas: this.fb.array([]) });
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display states
  setLga() {
    const control = this.lgaForm.controls.Lgas as FormArray;
    this.filteredLga.forEach((e) => {
      control.push(
        this.fb.group({
          LgaName: e.LgaName,
          LgaCode: e.LgaCode,
          StateId: e.StateId,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.lgaForm.controls.Lgas as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter state
  selectLga(event: string) {
    this.filteredLga = this.lgas.filter((s) => s.StateId === event);
    this.selectedStateId = event;
    const control = this.lgaForm.controls.Lgas as FormArray;

    if (this.filteredLga.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setLga();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Country
  addLga() {
    const control = this.lgaForm.controls.Lgas as FormArray;
    control.insert(
      0,
      this.fb.group({
        LgaName: ['', Validators.required],
        LgaCode: ['', Validators.required],
        StateId: this.selectedStateId,
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteLga(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.lgaForm.controls.Lgas as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.lgas.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.lgas[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'lga';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('lga');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
